import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FuelEntry, FuelFormSubmission, TruckOption } from '../interfaces';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class FuelService {
  constructor(private api: ApiService) {}

  getTruckList(): Observable<TruckOption[]> {
    return this.api.get<TruckOption[]>('/api/trucks');
  }

  submitFuelEntry(submission: FuelFormSubmission): Observable<FuelEntry> {
    return this.api.post<FuelEntry>('/api/fuel', submission);
  }

  getFuelEntries(year?: number, month?: number): Observable<FuelEntry[]> {
    let path = '/api/fuel';
    const params: string[] = [];
    if (year != null) params.push(`year=${year}`);
    if (month != null) params.push(`month=${month}`);
    if (params.length) path += `?${params.join('&')}`;
    return this.api.get<FuelEntry[]>(path);
  }
}
